<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="text-center my-5" >
                <template #default>مزاج شما اعتدال است.   </template>
                </m-h1></template>
                </m-div><m-audio v-bind='{...{"audio":"https:\/\/dl.mehrdl.top\/Music\/A\/F\/Moein-paricheh\/06%20Paricheh.mp3"},...{}}' :style='""' class="" ></m-audio>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mAudio from '@moeinmdn/miw-alpha-components/src/package/Tags/Audio';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mAudio },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
